import { render, staticRenderFns } from "./IconTextBold.vue?vue&type=template&id=0e4f08d0&"
import script from "./IconTextBold.vue?vue&type=script&lang=js&"
export * from "./IconTextBold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e4f08d0')) {
      api.createRecord('0e4f08d0', component.options)
    } else {
      api.reload('0e4f08d0', component.options)
    }
    module.hot.accept("./IconTextBold.vue?vue&type=template&id=0e4f08d0&", function () {
      api.rerender('0e4f08d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconTextBold.vue"
export default component.exports